import axios from "../axios";

const API_URL = axios.defaults.baseURL;
const PROFILE_URL = "/profile/"
const OTHER_URL = "/organiser"

export const getProfileOrganizer = (profileId) => {
    return axios.get(API_URL + PROFILE_URL + `${profileId}` + OTHER_URL);
};

export const addProfileOrganizer = (profileId, payload) => {
    return axios.post(API_URL + PROFILE_URL + `${profileId}` + OTHER_URL, payload);
};

export const editProfileOrganizer = (profileId, userId) => {
    return axios.put(API_URL + PROFILE_URL + `${profileId}` + OTHER_URL + `/${userId}`);
};

export const deleteProfileOrganizer = (profileId, userEmail) => {
    return axios.delete(API_URL + PROFILE_URL + `${profileId}` + OTHER_URL + `/${userEmail}`);
};


